export const bridgeActionTypes = {
	BRIDGE_GET_EPISODES_REQUEST: 'BRIDGE_GET_EPISODES_REQUEST',
	BRIDGE_GET_EPISODES_SUCCESS: 'BRIDGE_GET_EPISODES_SUCCESS',
	BRIDGE_GET_EPISODES_ERROR: 'BRIDGE_GET_EPISODES_ERROR',
	BRIDGE_GET_ROOM_REQUEST: 'BRIDGE_GET_ROOM_REQUEST',
	BRIDGE_GET_ROOM_SUCCESS: 'BRIDGE_GET_ROOM_SUCCESS',
	BRIDGE_GET_ROOM_ERROR: 'BRIDGE_GET_ROOM_ERROR',
	BRIDGE_GET_TASK_REQUEST: 'BRIDGE_GET_TASK_REQUEST',
	BRIDGE_GET_TASK_SUCCESS: 'BRIDGE_GET_TASK_SUCCESS',
	BRIDGE_GET_TASK_ERROR: 'BRIDGE_GET_TASK_ERROR',
	BRIDGE_OPEN_LOCKER_COMPUTER_MODAL: 'BRIDGE_OPEN_LOCKER_COMPUTER_MODAL',
	BRIDGE_CLOSE_LOCKER_COMPUTER_MODAL: 'BRIDGE_CLOSE_LOCKER_COMPUTER_MODAL',
	BRIDGE_FINISH_TASK_REQUEST: 'BRIDGE_FINISH_TASK_REQUEST',
	BRIDGE_FINISH_TASK_SUCCESS: 'BRIDGE_FINISH_TASK_SUCCESS',
	BRIDGE_FINISH_TASK_ERROR: 'BRIDGE_FINISH_TASK_ERROR',
	BRIDGE_CHECK_LOCKER_PASSWORD_REQUEST: 'BRIDGE_CHECK_LOCKER_PASSWORD_REQUEST',
	BRIDGE_CHECK_LOCKER_PASSWORD_SUCCESS: 'BRIDGE_CHECK_LOCKER_PASSWORD_SUCCESS',
	BRIDGE_CHECK_LOCKER_PASSWORD_WRONG: 'BRIDGE_CHECK_LOCKER_PASSWORD_WRONG',
	BRIDGE_CHECK_LOCKER_PASSWORD_ERROR: 'BRIDGE_CHECK_LOCKER_PASSWORD_ERROR',
	BRIDGE_OPEN_LOCKER_AGENDA_MODAL: 'BRIDGE_OPEN_LOCKER_AGENDA_MODAL',
	BRIDGE_CLOSE_LOCKER_AGENDA_MODAL: 'BRIDGE_CLOSE_LOCKER_AGENDA_MODAL',
	BRIDGE_CLOSE_ROOM_DIALOG: 'BRIDGE_CLOSE_ROOM_DIALOG',
	BRIDGE_SEND_ROOM_MESSAGE_REQUEST: 'BRIDGE_SEND_ROOM_MESSAGE_REQUEST',
	BRIDGE_CLEAR_TASK_FINISH_RESULT: 'BRIDGE_CLEAR_TASK_FINISH_RESULT',
	BRIDGE_PREPARE_GAME_RESUME: 'BRIDGE_PREPARE_GAME_RESUME',
	BRIDGE_CLEAR_GAME_RESUME: 'BRIDGE_CLEAR_GAME_RESUME',
	BRIDGE_GET_MAP_REQUEST: 'BRIDGE_GET_MAP_REQUEST',
	BRIDGE_GET_MAP_SUCCESS: 'BRIDGE_GET_MAP_SUCCESS',
	BRIDGE_GET_MAP_ERROR: 'BRIDGE_GET_MAP_ERROR',
} as const;

export const LOCKER_COMPUTER_FORM = 'lockerComputerForm';
export const BRIDGE_GRADE_ID = 8;
